import { RitualActionTypes } from './constants';
import { RitualActionType } from './actions';

export interface Ritual {
    id: number;
    name: string;
    description?: string;
    category?: string;
    defaultPrice?: number;
    imageUrl?: string;
    createdAt: string;
    updatedAt: string;
    isActive?: boolean;
    services?: any[];
    products?: any[];
    poojaris?: any[];
}

export interface RitualState {
    rituals: Ritual[];
    ritual: Ritual | null;
    totalRituals: number;
    totalPages: number;
    currentPage: number;
    loading: boolean;
    error: string | null;
    createdRitual: Ritual | null;
    isRitualCreated: boolean;
    ritualDetailsById: Ritual | null;
}

const INIT_STATE: RitualState = {
    rituals: [],
    ritual: null,
    totalRituals: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,
    createdRitual: null,
    isRitualCreated: false,
    ritualDetailsById: null,
};

const RitualReducer = (state: RitualState = INIT_STATE, action: RitualActionType): RitualState => {
    switch (action.type) {
        case RitualActionTypes.API_RESPONSE_SUCCESS:
            switch ((action.payload as any).actionType) {
                case RitualActionTypes.GET_RITUALS: {
                    const data = (action.payload as any).data;
                    return {
                        ...state,
                        rituals: Array.isArray(data) ? data : data?.results || [],
                        totalRituals: data?.totalResults || data?.length || 0,
                        totalPages: data?.totalPages || 1,
                        currentPage: data?.currentPage || 1,
                        loading: false,
                        error: null,
                    };
                }

                case RitualActionTypes.GET_RITUAL_BY_ID: {
                    return {
                        ...state,
                        ritual: (action.payload as any).data,
                        loading: false,
                        error: null,
                    };
                }

                case RitualActionTypes.ADD_RITUAL: {
                    return {
                        ...state,
                        createdRitual: (action.payload as any).data,
                        isRitualCreated: true,
                        loading: false,
                        error: null,
                    };
                }

                case RitualActionTypes.UPDATE_RITUAL: {
                    return {
                        ...state,
                        ritual: (action.payload as any).data,
                        loading: false,
                        error: null,
                    };
                }

                case RitualActionTypes.DELETE_RITUAL: {
                    return {
                        ...state,
                        rituals: state.rituals.filter(ritual => ritual.id !== (action.payload as any).data),
                        loading: false,
                        error: null,
                    };
                }

                case RitualActionTypes.TAG_SERVICE_TO_RITUALS:
                case RitualActionTypes.TAG_PRODUCT_TO_RITUALS:
                case RitualActionTypes.ASSIGN_RITUAL_TO_POOJARI:
                case RitualActionTypes.UPDATE_POOJARI_RITUAL:
                case RitualActionTypes.REMOVE_RITUAL_FROM_POOJARI: {
                    return {
                        ...state,
                        loading: false,
                        error: null,
                    };
                }

                case RitualActionTypes.GET_RITUALS_BY_POOJARI:
                case RitualActionTypes.GET_POOJARIS_BY_RITUAL: {
                    return {
                        ...state,
                        rituals: Array.isArray((action.payload as any).data)
                            ? (action.payload as any).data
                            : (action.payload as any).data?.results || [],
                        loading: false,
                        error: null,
                    };
                }

                default:
                    return state;
            }

        case RitualActionTypes.API_RESPONSE_ERROR:
            switch ((action.payload as any).actionType) {
                case RitualActionTypes.GET_RITUALS:
                case RitualActionTypes.GET_RITUAL_BY_ID:
                case RitualActionTypes.ADD_RITUAL:
                case RitualActionTypes.UPDATE_RITUAL:
                case RitualActionTypes.DELETE_RITUAL:
                case RitualActionTypes.TAG_SERVICE_TO_RITUALS:
                case RitualActionTypes.TAG_PRODUCT_TO_RITUALS:
                case RitualActionTypes.ASSIGN_RITUAL_TO_POOJARI:
                case RitualActionTypes.GET_RITUALS_BY_POOJARI:
                case RitualActionTypes.GET_POOJARIS_BY_RITUAL:
                case RitualActionTypes.UPDATE_POOJARI_RITUAL:
                case RitualActionTypes.REMOVE_RITUAL_FROM_POOJARI: {
                    return {
                        ...state,
                        loading: false,
                        error: (action.payload as any).error,
                    };
                }

                default:
                    return state;
            }

        case RitualActionTypes.GET_RITUALS:
        case RitualActionTypes.GET_RITUAL_BY_ID:
        case RitualActionTypes.ADD_RITUAL:
        case RitualActionTypes.UPDATE_RITUAL:
        case RitualActionTypes.DELETE_RITUAL:
        case RitualActionTypes.TAG_SERVICE_TO_RITUALS:
        case RitualActionTypes.TAG_PRODUCT_TO_RITUALS:
        case RitualActionTypes.ASSIGN_RITUAL_TO_POOJARI:
        case RitualActionTypes.GET_RITUALS_BY_POOJARI:
        case RitualActionTypes.GET_POOJARIS_BY_RITUAL:
        case RitualActionTypes.UPDATE_POOJARI_RITUAL:
        case RitualActionTypes.REMOVE_RITUAL_FROM_POOJARI: {
            return {
                ...state,
                loading: true,
                error: null,
            };
        }

        case RitualActionTypes.RESET: {
            return {
                ...INIT_STATE,
            };
        }

        default:
            return state;
    }
};

export default RitualReducer;
